import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useId } from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { LinkStyle, HighlightStyle } from '@micromag/core/components';
import { getStyleFromLink, getStyleFromHighlight, getStyleFromText, getStyleFromMargin } from '@micromag/core/utils';

var styles = {"container":"micromag-element-text-container","showEmpty":"micromag-element-text-showEmpty","withLineClamp":"micromag-element-text-withLineClamp"};

var propTypes = {
  body: PropTypes.string,
  textStyle: PropTypes$1.textStyle,
  linksStyle: PropTypes$1.textStyle,
  margin: PropTypes$1.margin,
  lineClamp: PropTypes.number,
  showEmpty: PropTypes.bool,
  className: PropTypes.string,
  emptyClassName: PropTypes.string,
  inline: PropTypes.bool,
  refText: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any // eslint-disable-line
  })])
};
var defaultProps = {
  body: null,
  textStyle: null,
  linksStyle: null,
  margin: null,
  lineClamp: null,
  showEmpty: false,
  className: null,
  emptyClassName: null,
  inline: false,
  refText: null
};
var Text = function Text(_ref) {
  var body = _ref.body,
    textStyle = _ref.textStyle,
    linksStyle = _ref.linksStyle,
    margin = _ref.margin,
    lineClamp = _ref.lineClamp,
    showEmpty = _ref.showEmpty,
    className = _ref.className,
    emptyClassName = _ref.emptyClassName,
    inline = _ref.inline,
    refText = _ref.refText;
  var _ref2 = textStyle || {},
    _ref2$link = _ref2.link,
    linkStyle = _ref2$link === void 0 ? null : _ref2$link,
    _ref2$highlight = _ref2.highlight,
    highlightStyle = _ref2$highlight === void 0 ? null : _ref2$highlight;
  var finalStyle = {};
  var finalLinkStyle = linkStyle !== null ? getStyleFromLink(linkStyle) : null;
  var finalHighlightStyle = highlightStyle !== null ? getStyleFromHighlight(highlightStyle) : null;
  if (highlightStyle !== null) {
    console.log('highlightStyle', highlightStyle);
  }
  if (textStyle !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromText(textStyle));
  }
  if (lineClamp !== null) {
    finalStyle.WebkitLineClamp = lineClamp;
  }
  if (margin !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromMargin(margin));
  }
  if (linksStyle !== null) {
    finalLinkStyle = _objectSpread(_objectSpread({}, finalLinkStyle), getStyleFromText(linksStyle));
  }
  var needsId = finalLinkStyle !== null || highlightStyle !== null;
  var uniqueId = useId();
  var id = needsId ? "text-component-".concat(uniqueId) : null;
  var tagProps = {
    id: id,
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.withLineClamp, lineClamp !== null), styles.showEmpty, showEmpty), emptyClassName, showEmpty && emptyClassName !== null), className, className !== null)]),
    style: finalStyle,
    dangerouslySetInnerHTML: {
      __html: body
    },
    ref: refText
  };
  var Tag = "".concat(inline ? 'span' : 'div');
  return /*#__PURE__*/React.createElement(React.Fragment, null, finalLinkStyle !== null ? /*#__PURE__*/React.createElement(LinkStyle, {
    selector: "#".concat(CSS.escape(id)),
    style: finalLinkStyle
  }) : null, finalHighlightStyle !== null ? /*#__PURE__*/React.createElement(HighlightStyle, {
    selector: "#".concat(CSS.escape(id)),
    style: finalHighlightStyle
  }) : null, /*#__PURE__*/React.createElement(Tag, tagProps));
};
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export { Text as default };
